import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { IColorTheme } from '../../types/itemTypes'

const Styles = styled.button`
  justify-content: center;
  border: 1px solid;
  box-sizing: border-box;
  border-color: ${({ theme: { colourHighlight } }): string => colourHighlight};
  background-color: transparent;
  color: ${({ theme: { colourHighlight } }): string => colourHighlight};
  &.details-button-showing {
    :hover {
      background-color: ${({ theme: { hover } }): string => hover};
      color: ${({ theme: { colourTextOnHighlight } }): string => colourTextOnHighlight};
    }
  }
`
export interface ISecondaryButtonProps {
  isActive?: boolean
  colorTheme: IColorTheme
  label: string
  onClick: () => void
}
export default function SecondaryButton(
  props: ISecondaryButtonProps,
): ReactElement {
  const {
    isActive, colorTheme, label, onClick,
  } = props

  const getClasses = (): string => {
    if (!isActive) return 'details-button-showing'
    return ''
  }

  return (
    <Styles onClick={onClick} className={getClasses()} theme={colorTheme}>
      {isActive ? 'Close' : label}
    </Styles>
  )
}
